import React from 'react';

class Error extends React.Component {

  render() {
    return (
      <div>404</div>
    )
  }
}

export default Error;